module.exports = __webpack_public_path__ + "img/addPlus-icon.5fc2bad8.svg";